import React, { useMemo } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar";
import AdminNavbar from "components/Navbars/AdminNavbar";
import AdminFooter from "components/Footers/AdminFooter";
import PageHeader from "components/ui/PageHeader";
import accountantRoutes from "accountantRoutes";
import useCurrentUser from "hooks/useCurrentUser";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const AccountantLayout = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { user } = useCurrentUser() || {};

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const sidebarRoutes = useMemo(
    () => accountantRoutes.filter((r) => r.sidebar !== false),
    []
  );

  const brandText = useMemo(() => {
    for (let r of accountantRoutes) {
      if (location.pathname.includes((r.layout || "") + r.path)) return r.name;
    }
    return "Accountant";
  }, [location.pathname]);

  const branchName = user?.branch?.name || user?.tenant?.name || "Books";
  const userName = user?.firstName || (user?.username ? user.username.split("@")[0] : "");

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/accountant/dashboard" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/accountant/Profile" />
        <PageHeader
          role="accountant"
          eyebrow={`${branchName} · Accountant`}
          title={userName ? `${greeting()}, ${userName}` : brandText}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Outlet />
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default AccountantLayout;
